'use strict';
import React, { useEffect, useRef, useState } from 'react';
import Player, { useMessageContextRef, ACTIONS, EVENTS } from 'griffith';
import styles from './assets/index.module.scss';
import { userStore, videoStore } from '../../store';
import Header from '../common/Header';
import usePlayer from '../../utils/usePlayer';
import { useNavigate } from 'react-router-dom';
import useUrlSearch from '../../utils/useUrlSearch';
import useService from './service';
import { Toast } from 'antd-mobile'

export default function DDS_lanhupage_0() {

  const { videos } = videoStore;

  const navigate = useNavigate();
  const { userId } = userStore;

  const [learn, setLearning] = useState({
    video: {}
  })

  const { getByKey } = useUrlSearch();
  const messageContextRef = useMessageContextRef();
  const { endFlag, pauseFlag, setStartFlag, setPauseFlag, time } = usePlayer();
  const { record, recordUpdate } = useService();

  useEffect(() => {
    let video;
    if (videos) {
      // console.log(videos)
      video = videos.filter(v => v.videoId === getByKey('id'))[0]   // videoId
    } else {
      const cache = localStorage.getItem('videoCache');
      // console.log(cache)
      if (cache) {
        const videoCache = JSON.parse(cache)
        video = videoCache.filter(v => v.videoId === getByKey('id'))[0]
      }
    }
    setLearning({
      video
    })
    videoStore.active = video
    return () => {

    }
  }, [videos])

  useEffect(() => {
    // 测试放行
    if (!localStorage.getItem(`${userId}_faceValidate`)) {
      navigate('/camera')
    }
  }, [])

  messageContextRef.useEvent(EVENTS.PLAY, ({ currentTime, duration, error }) => {
    if(duration.toString() === 'NaN'){
      setPauseFlag(true)
      messageContextRef.dispatchAction(ACTIONS.PAUSE)
      return
    }
    if (time.current.total === 0 && !endFlag) {
      time.current.duration = duration;
      time.current.total = duration * (100 - record) / 100; // 更新学习进度
      setStartFlag(true)
    }
    if (pauseFlag) {
      setPauseFlag(false)
    }
  })

  messageContextRef.useEvent(EVENTS.ENDED, ({ currentTime, duration, error }) => {
    //usePlayer处理
  })

  messageContextRef.useEvent(EVENTS.PAUSE, ({ currentTime, duration, error }) => {
    // 更新剩余时间
    // time.current.total = duration - currentTime
    setPauseFlag(true)
  })

  messageContextRef.useEvent(EVENTS.ENDED, ({ currentTime, duration, error }) => {
    // 强制结束
    time.current.total < 1 && recordUpdate(100)
  })

  messageContextRef.useEvent(EVENTS.ERROR, ({ currentTime, duration, error: { code, message, name } }) => {
    Toast.show({
      content: name + ':' + code + ':' + message
    })
  })

  const exam = () => {
    navigate(`/lanhu_7?exam=${learn.video.videoId}`)
  }

  return (
    <div className={`${styles.page} flex-col`}>
      <div className={`${styles.box1} flex-col`}>
        {/* <Header className={`${styles.Header} flex-col`} >
          <div className={`${styles.mod1} flex-col`} />
        </Header> */}
        <div className={`${styles.Body} flex-col`}>
          <div className={`${styles.layer1} flex-col`}>
            <div className={`${styles.main1} flex-col`} >
              <Player
                // key={learn.video.videoId}
                messageContextRef={messageContextRef}
                sources={{ hd: { play_url: learn.video.videoUrl?.replace('http://192.169.250.225:8888', 'https://onlinetest.shasteel.cn') } }}
              />
            </div>
            <div className={`${styles.ImageText1} flex-col`}>
              <div className={`${styles.layer2} flex-row justify-between`}>
                <div className={`${styles.section1} flex-col`} />
                <div className={`${styles.TextGroup1} flex-col`}>
                  <span className={`${styles.txt1}`}>{learn.video.videoTitle}</span>
                </div>
              </div>
            </div>
            <span className={`${styles.txt2}`}>{learn.video.videoTitle}</span>
            <div className={`${styles.main2} flex-col`} />
            <div className={`${styles.ImageText2} flex-col`}>
              <div className={`${styles.section2} flex-row justify-between`}>
                <div className={`${styles.group1} flex-col`} />
                <div className={`${styles.TextGroup2} flex-col`}>
                  <span className={`${styles.info1}`}>课程介绍</span>
                </div>
              </div>
            </div>
            <span className={`${styles.txt3}`}>{learn.video.videoSubtitle}</span>
            <div className={`${styles.main3} flex-col`} />
            {
              // endFlag ? (
              //   <div className={`${styles.box5} flex-col`} onClick={exam}>
              //     <span className={`${styles.word3}`}>开始考试</span>
              //   </div>
              // ) : (
              //   <div className={`${styles.main4} flex-col`}>
              //     <span className={`${styles.info2}`}>开始考试</span>
              //   </div>
              // )
              // record === '100' && 'finished'
            }
          </div>
        </div>
      </div>
    </div>
  );
}
